package com.example.mystybag.appCore.model.pages

data class MerchantProfileDetailsUIState(
    val isLoading: Boolean = false,
    val isSaving: Boolean = false,
    val email: String = "",
    val companyName: String = "",
    val dialCode: String = "",
    val phoneNumber: String = "",
    val bulstat: String = "",
    val iban: String = "",
    val logoImageFileName: String? = null,
    val logoImageUrl: String? = null,
    val countryId: Int? = null,
    val cityId: Long? = null,
    val companyStreet: String = "",
    // Error messages
    val companyNameError: String? = null,
    val phoneNumberError: String? = null,
    val bulstatError: String? = null,
    val ibanError: String? = null,
    val companyStreetError: String? = null
)
